import Axios from 'axios';

let SobjectService = {};

(function () {

  this.getSubjects = function (subject_id) {
    const url = `${process.env.VUE_APP_API_URL}cargaasignaturas`;
    let data = {"id_asignatura": subject_id};
        return Axios.post(url, data);
  };


  this.getDataSubjects = function (id_curso, id_asignatura) {
  const url = `${process.env.VUE_APP_API_URL_LOCAL}/Capitulo2/v2/getCapitulosAsignaturaCurso`;
  let data = { "IdCurso": id_curso, "IdAsignatura": id_asignatura };
  return Axios.post(url, data);
};


this.updateChapter = function (payload) {
    const url = `${process.env.VUE_APP_API_URL_LOCAL}/v2/chapters/update/chapter`;
    const requestBody = {
      Chapter: payload,
      Commit: true,
      IncludeLogs: true
    };
    return Axios.post(url, requestBody);
  };

    
}).apply(SobjectService);

export default SobjectService;
